"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTranslation = createTranslation;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _vue = _interopRequireDefault(require("vue"));

var _vueI18n = _interopRequireDefault(require("vue-i18n"));

var _en = _interopRequireDefault(require("element-ui/lib/locale/lang/en"));

var _zhCN = _interopRequireDefault(require("element-ui/lib/locale/lang/zh-CN"));

var _zhTW = _interopRequireDefault(require("element-ui/lib/locale/lang/zh-TW"));

var _locale = _interopRequireDefault(require("element-ui/lib/locale"));

var _helper = require("@/services/helper/helper.service");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function createTranslation() {
  var vueInstance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _vue.default;
  vueInstance.use(_vueI18n.default);
  var helper = new _helper.Helper();
  var locale = helper.getCookie(process.env.VUE_APP_LOCALE_COOKIE);

  if (!locale) {
    locale = process.env.VUE_APP_LOCALE || 'en';
    helper.setCookie(process.env.VUE_APP_LOCALE_COOKIE, locale, helper.getDomain(), 90);
  }

  var messages = {
    en: _objectSpread(_objectSpread({}, require("./en.json")), _en.default),
    sc: _objectSpread(_objectSpread({}, require("./sc.json")), _zhCN.default),
    tc: _objectSpread(_objectSpread({}, require("./tc.json")), _zhTW.default)
  };
  var i18n = new _vueI18n.default({
    locale: locale,
    fallbackLocale: 'en',
    silentTranslationWarn: true,
    messages: messages
  });

  _locale.default.i18n(function (key, value) {
    return i18n.t(key, value);
  });

  return i18n;
}